<template>
  <div class="table-container">
    <table class="table is-fullwidth is-narrow">
      <thead>
        <tr class="is-unselectable">
          <th>Type</th>
          <th>Browser</th>
          <th>OS</th>
          <th>Browser ID</th>
          <th>IP</th>
          <th>Created</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="session of sessions"
          :key="session.id"
          :class="{ 'is-selected': fingerprint === session.fp }"
        >
          <td class="is-capitalized">
            {{ session.meta.type }}
          </td>

          <td class="is-capitalized">
            {{ session.meta.browserName }} {{ session.meta.browserVersion }}
          </td>

          <td class="is-capitalized">
            {{ session.meta.osName }} {{ session.meta.osVersion }}
          </td>

          <td>
            {{ session.fp }}

            <span
              v-if="fingerprint === session.fp"
              class="margin-left-5 tag is-default small"
              >Current</span
            >
          </td>

          <td>
            {{ session.meta.ip }}
          </td>

          <td>{{ active(session) }}</td>

          <td>
            <span v-if="session.isLoading" class="spinner smaller"></span>
            <button v-if="fingerprint !== session.fp && !session.isLoading" class="button is-small smaller is-danger" @click="removeSession(session)"
              >Delete</button
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { postApi } from "@/utils/http";
import { fromNow } from "@/utils/date";
import fp from "@/utils/fingerprint";

export default {
  data() {
    return {
      sessions: [],
      fingerprint: null,
      isLoading: false
    };
  },
  computed: {
    active() {
      return session => fromNow(session.meta.timeCreated);
    }
  },

  created() {
    this.getSessions();
  },
  async mounted() {
    this.$nextTick(async () => {
      this.fingerprint = await fp.get(true);
    });
  },
  methods: {
    async getSessions() {
      try {
        const res = await postApi("sessions", {});

        this.sessions = res[0];
      } catch (e) {
        this.$helpers.notify("Error", "Could not get sessions.", "danger");
      }
    },
    async removeSession(session) {
      this.$set(
        this.sessions,
        this.sessions.findIndex(x => x.id === session.id),
        { ...session, isLoading: true }
      );
      await postApi("logout/session", { id: session.id });

      this.$delete(
        this.sessions,
        this.sessions.findIndex(x => x.id === session.id)
      );
    }
  }
};
</script>
